import type { ZipBoundary } from './api.js';
import type { Geography } from './types.js';
import { uniqueBoundarySegments } from './geo-topology.js';

export function isZipIncluded(zip: ZipBoundary, geography: Geography): boolean {
  return geography.zipCodes.length > 0 ? geography.zipCodes.includes(zip.zip) : zip.included;
}

/** Keeps the all-ZIP hit target separate from the included-only visual scene. */
export function buildMapboxGeoData(zips: ZipBoundary[], geography: Geography) {
  const toPolygon = (zip: ZipBoundary) => ({ type: 'Feature' as const, properties: { zip: zip.zip }, geometry: { type: 'Polygon' as const, coordinates: zip.rings } });
  const included = zips.filter((zip) => isZipIncluded(zip, geography));
  return {
    hitPolygons: { type: 'FeatureCollection' as const, features: zips.map(toPolygon) },
    visualPolygons: { type: 'FeatureCollection' as const, features: included.map(toPolygon) },
    boundaries: {
      type: 'FeatureCollection' as const,
      features: uniqueBoundarySegments(included.flatMap((zip) => zip.rings)).map((segment) => ({
        type: 'Feature' as const, properties: {}, geometry: { type: 'LineString' as const, coordinates: [segment.start, segment.end] },
      })),
    },
    labels: {
      type: 'FeatureCollection' as const,
      features: included.map((zip) => ({ type: 'Feature' as const, properties: { zip: zip.zip }, geometry: { type: 'Point' as const, coordinates: [zip.centroid.lng, zip.centroid.lat] } })),
    },
  };
}
